import { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import { ApolloProvider } from '@apollo/client/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React, { ComponentType, ReactNode } from 'react'
import { createRoot } from 'react-dom/client'
import { HashRouter } from 'react-router-dom'
import { RecoilRoot } from 'recoil'
import App from './App'
import { TitleProvider } from './components/TitleProvider'

// Shared render entry for both the real and demo boots. The auth provider is
// injected so the real path can wrap Amplify's Authenticator.Provider while the
// demo path supplies a self-contained provider that never touches Cognito.
export function renderApp(
    client: ApolloClient<NormalizedCacheObject>,
    AuthProvider: ComponentType<{ children: ReactNode }>
): void {
    const container = document.getElementById('root')
    const root = createRoot(container!)
    root.render(
        <React.StrictMode>
            <QueryClientProvider client={new QueryClient()}>
                <ApolloProvider client={client}>
                    <HashRouter>
                        <AuthProvider>
                            <RecoilRoot>
                                <TitleProvider>
                                    <App />
                                </TitleProvider>
                            </RecoilRoot>
                        </AuthProvider>
                    </HashRouter>
                </ApolloProvider>
            </QueryClientProvider>
        </React.StrictMode>
    )
}
